import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Cognito from '../../lib/cognito';
import Chrome from '../Chrome';
import LayoutMetaData from './LayoutMetaData';
import { isChromelessRoute } from '../../utils/layout-utils';

class Layout extends Component {
  componentDidMount() {
    this.setupSessionCheck();
  }

  async setupSessionCheck() {
    const session = await Cognito.fetchCognitoCredentials();
    const { checkForSession, getUser } = this.props;
    const { token } = session || {};
    await checkForSession();
    if (token) getUser(token);
  }

  render() {
    const { children, location } = this.props;
    const { pathname } = location;
    return (
      <div className="layout anti-aliased source-sans">
        <LayoutMetaData pathname={pathname} />
        {isChromelessRoute(pathname) ? children : <Chrome>{children}</Chrome>}
      </div>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  checkForSession: PropTypes.func.isRequired,
  getUser: PropTypes.func,
};

Layout.defaultProps = {
  getUser: () => {},
};

export default withRouter(Layout);
